import React from 'react';
import { Button, Grid } from '@mui/material';
import InputControl from '../Forms/InputControl';

/**
 * ORMFilters Component
 *
 * Purpose:
 *  - Renders a simple filter form with "Start Date" and "End Date" fields.
 *  - Allows the user to select a date range and submit it.
 *
 * Current Usage:
 *  - This component is used in the TriggerTitlesResult component.
 */
const ORMFilters = ({ handleSubmit, defaultStartDate = '', defaultEndDate = '', btnName = 'Submit' }) => {
  // Local state for the two date inputs
  const [formData, setFormData] = React.useState({
    startDate: defaultStartDate,
    endDate: defaultEndDate,
  });

  // Update state when any input changes
  const handleInputChange = e => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  return (
    <Grid
      container
      spacing={2}
      sx={{
        alignItems: 'flex-end',
      }}
    >
      {/* Start Date Field */}
      <Grid size={{ lg: 2, md: 3, sm: 4, xs: 12 }}>
        <InputControl
          label='Start Date'
          name='startDate'
          type='date'
          onChange={handleInputChange}
          value={formData?.startDate}
        />
      </Grid>

      {/* End Date Field */}
      <Grid size={{ lg: 2, md: 3, sm: 4, xs: 12 }}>
        <InputControl
          label='End Date'
          name='endDate'
          type='date'
          onChange={handleInputChange}
          value={formData?.endDate}
        />
      </Grid>

      {/* Submit Button (disabled unless both dates are filled) */}
      <Grid size={{ md: 2, sm: 4, xs: 12 }}>
        <Button onClick={() => handleSubmit(formData)} disabled={!(formData.startDate && formData.endDate)}>
          {btnName}
        </Button>
      </Grid>
    </Grid>
  );
};

export default ORMFilters;
